import React from "react";

import SectionSidebar, { ISectionGroup, SectionIcon } from "src/components/SectionSidebar/SectionSidebar";

import { MANAGE_EVENT_GROUPS, MANAGE_EVENT_SECTIONS } from "./manage-event-sections";

interface IProps {
  eventTitle?: string;
  clubName?: string;
  clubLogoUrl?: string;
  clubLocation?: string;
  eventUrl: string;
  activeTab: number;
  badges: Record<string, number>;
  onSelect(index: number): void;
  mobileOpen: boolean;
  onMobileClose(): void;
}

const groups: ISectionGroup[] = MANAGE_EVENT_GROUPS.map((group) => ({
  label: group,
  items: MANAGE_EVENT_SECTIONS.filter((section) => section.group === group).map((section) => ({
    id: String(section.tabIndex),
    label: section.label,
    icon: <SectionIcon name={section.icon} />,
    badge: undefined,
  })),
}));

const EventManageSidebar: React.FC<IProps> = ({
  eventTitle,
  clubName,
  clubLogoUrl,
  clubLocation,
  eventUrl,
  activeTab,
  badges,
  onSelect,
  mobileOpen,
  onMobileClose,
}) => {
  const navGroups = groups.map((group) => ({
    ...group,
    items: group.items.map((item) => {
      const section = MANAGE_EVENT_SECTIONS.find((entry) => String(entry.tabIndex) === item.id);
      return {
        ...item,
        badge: section ? badges[section.id] || 0 : 0,
      };
    }),
  }));

  return (
    <SectionSidebar
      storageKey="eagerdog.manageEventSidebarCollapsed"
      menuLabel="Event menu"
      eyebrow={clubName || eventTitle}
      header={{
        title: eventTitle || "Event",
        subtitle: clubLocation,
        imageUrl: clubLogoUrl,
        imageAlt: clubName || "Club logo",
        fallbackName: clubName || eventTitle,
        linkTo: eventUrl,
        linkLabel: "View Event",
      }}
      groups={navGroups}
      activeId={String(activeTab)}
      onSelect={(id) => onSelect(Number(id))}
      mobileOpen={mobileOpen}
      onMobileClose={onMobileClose}
    />
  );
};

export default EventManageSidebar;
